const initialState = {
    drivesList: {},
    driveDateCalender: {}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case 'SET_DRIVES_LIST':
        return {
          ...state,
          drivesList: action.data,
        }
        case 'SET_DRIVES_DATE_CALENDER':
          return {
            ...state,
            driveDateCalender: action.data,
          }
      default:
        return state
    }
  }
  